
<router-outlet></router-outlet>

<!-- Shared device bar (id / version / fullscreen) — prikazan stalno, kao na KD/CD. -->
<app-device-info-bar
  [devMode]="!environment.production"
  (openSettings)="router.navigate(['/app'])"
></app-device-info-bar>
